

class Config{
  
//HOST = 'http://10.1.200.253:8000/';  
 //HOST = 'https://test.senfin.com/api-proxy2/';

}

// export const HOST = process.env.NODE_ENV === 'development' ? 'http://10.31.0.22:18080/api-proxy/' : 'https://www.senfin.com/fdapp/api-proxy/';

export default new Config();
export const HOST = 'https://www.senfin.com/fdapp/api-proxy/'; //Publish go Live  access and change home as "fixed-deposit/" in package

// export const HOST = 'http://192.168.253.5:8080/api-proxy/'; //Publish go Test Server New Test Serve

// export const HOST = 'http://192.168.200.253:8080/api-proxy/'; //our test server

// export const HOST = 'http://10.31.0.22:18080/api-proxy/'; //Test Server
// export const HOST = 'http://192.168.252.16:48080/api-proxy/'; //Host Test production server

//export const Host = "http://10.1.200.253:8000/";
//export const Host = "http://10.1.200.253:8002/api/";
// export const HOST = 'https://test.senfin.com/api-proxy2/'
// export const Host = "https://admin.senfinassetmanagement.com/api/";
// export const Host = "http://localhost:8000/api/";

//module.exports = new Config();

